"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const styled_components_1 = __importDefault(require("styled-components"));
const Back_svg_1 = __importDefault(require("../../../../../../assets/icons/dashboard/Back.svg"));
const components_2 = require("../../../../../../components");
const core_1 = require("../../../../../../core");
require("./types");
const HowToFixRoot = styled_components_1.default.div `
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  height: inherit;
  width: inherit;
  z-index: 100;
  padding: ${components_1.SIZE_S} ${components_1.SIZE_L};
`;
const HowToFixContentWrapper = styled_components_1.default.div `
  margin-top: ${components_1.SIZE_M};
`;
const HowToFixSeparator = styled_components_1.default(components_1.ControlSeparator) `
  height: 32px;
`;
const BottlenecksWidgetLayout = react_1.default.memo(({ howToFixContent, howToFixTitle, content, onBackClick }) => {
    const { t } = core_1.useFeatureContext();
    const HowToFixPage = (react_1.default.createElement(HowToFixRoot, null,
        react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, align: components_1.STACK_ALIGN.center, indentVertical: components_1.INDENT.xs, gap: components_1.STACK_GAP.m, size: { height: components_1.SIZE_XL }, distribution: components_1.STACK_DISTRIBUTION.lastFill },
            react_1.default.createElement(components_1.Icon, { src: Back_svg_1.default, size: components_1.ICON_SIZES.xl, onClick: onBackClick, style: { cursor: 'pointer' } }),
            react_1.default.createElement(HowToFixSeparator, null),
            react_1.default.createElement(components_1.Text, { weight: components_1.TEXT_WEIGHT.bold, size: components_1.TEXT_SIZE.l }, howToFixTitle)),
        react_1.default.createElement(HowToFixContentWrapper, null, howToFixContent)));
    return (react_1.default.createElement(components_2.DashboardPlate, { title: t('dashboard|bottlenecks|header'), content: howToFixContent ? HowToFixPage : content, hasViewMore: false }));
});
exports.default = BottlenecksWidgetLayout;
//# sourceMappingURL=BottlenecksWidgetLayout.js.map